import { mergeProps as _mergeProps, createTextVNode as _createTextVNode, createVNode as _createVNode } from "vue";
export default {
  name: 'ArrowLeftRightIcon',
  props: {
    size: {
      type: [Number, String],
      default: 24
    }
  },
  render() {
    const size = this.$props.size + 'px';
    const attrs = this.$data.attrs || {};
    const allAttrs = {
      width: attrs.width || size,
      height: attrs.height || size
    };
    return _createVNode("svg", _mergeProps({
      "xmlns": "http://www.w3.org/2000/svg",
      "class": "icon-tabler icon-tabler-arrow-left-right",
      "width": "24",
      "height": "24",
      "viewBox": "0 0 24 24",
      "stroke-width": "2",
      "stroke": "currentColor",
      "fill": "none",
      "stroke-linecap": "round",
      "stroke-linejoin": "round"
    }, allAttrs), [_createTextVNode("   "), _createVNode("path", {
      "stroke": "none",
      "d": "M0 0h24v24H0z",
      "fill": "none"
    }, null), _createTextVNode("   "), _createVNode("path", {
      "d": "M17 13l4 -4l-4 -4"
    }, null), _createTextVNode("   "), _createVNode("path", {
      "d": "M7 13l-4 -4l4 -4"
    }, null), _createTextVNode("   "), _createVNode("path", {
      "d": "M12 14a5 5 0 0 1 5 -5h4"
    }, null), _createTextVNode("   "), _createVNode("path", {
      "d": "M12 19v-5a5 5 0 0 0 -5 -5h-4"
    }, null), _createTextVNode(" ")]);
  }
};